import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import Form from './Form'
import ActionGet from '../../store/action/Keygroup/Fetch'
import ActionGetDetail from '../../store/action/Keygroup/View'
import ActionDelete from '../../store/action/Keygroup/Delete'
import ActionGetAllClient from '../../store/action/Client/FetchAll'
import ActionGetAllDivision from '../../store/action/Division/FetchAll'
import ActionGetAllSender from '../../store/action/Sender/FetchAll'
import CustomGrid from '../../infra/components/grid/custom-grid-without-search'
import "../../source/util.css"
import { IsEdit, IsCreate, IsView } from '../../store/constants'
import ComboboxInput from "../../infra/components/formInput/ComboboxInput";
import TextInputField from "../../infra/components/formInput/CustomTextInput";
import ActionFindByGroupId from '../../store/action/Previlage/FindByGroupId'
import {ClientId, DivisionId, PrevilageId} from "../../helper/HelperAuth";
import Swal from "sweetalert2";

class Page extends Component{
    constructor(props){
        super(props)
        this.state = {
            title: "Keygroup",
            classButton: "col-sm-2",
            isadmin:false,
            form: fromJS({
                show : false,
                actionType: '',
                item: fromJS({})
            }),
            formSearch: fromJS({
                "search": ""
            }),
            search: fromJS([
                { widthClass:'col-sm-12',id: 'search', placeholder: 'Search', label : '', value:'' },
            ]),
            searchForm : fromJS({
                "client-id"     : '',
                "division-id"   : '',
                "sender-id"     : ''
            }),
            columns:[
                { className : "col-sm-1", cfield: "counter", caption: "No" },
                { className : "col-sm-6", field: "group-name", caption: "Name", allowSearch: true },
                { className : "col-sm-1", cfield: "action", caption: "Actions", allowView: false }    
            ],
            errors: fromJS({})
        };
    
        this.showContent = this.showContent.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleFind = this.handleFind.bind(this);
        this.handleNew = this.handleNew.bind(this);
        this.handleViewClicked = this.handleViewClicked.bind(this);
        this.handleEditClicked = this.handleEditClicked.bind(this);
        this.handleRemoveClicked = this.handleRemoveClicked.bind(this);
        this.handleCancelForm = this.handleCancelForm.bind(this);
        this.handlePageChanged = this.handlePageChanged.bind(this);
    }

    async componentDidMount(){
        var isAdmin = await this.props.actionFindByGroupId();
        this.setState({isadmin:isAdmin})
        this.props.actionGetAllClient()
    }

    handleSearch(obj){
        this.setState({ formSearch: obj });
        this.refreshGrid(1, obj);
    }

    handleCancelForm(refresh){
        if(refresh){
            this.handleFindSearch(1);
        }
        this.setState({ 
            form:  fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            })
        })
    }

    handleNew(){
        this.setState({ 
            form:  fromJS({
                show: true,
                actionType: IsCreate,
                item: fromJS({})
            })
        })
    }

    handleViewClicked = (value) => {
        this.setState({ 
            form:  fromJS({
                show: true,
                actionType: IsView,
                item: value
            })
        })
    }

    handleEditClicked = async (value) => {
        var detail  = await this.props.actionGetDetail(value.get('group-id'));
        if(detail.size > 0){
            this.setState({ 
                form:  fromJS({
                    show: true,
                    actionType: IsEdit,
                    item: detail
                })
            })
        }else{
            this.setState({ 
                form:  fromJS({
                    show: true,
                    actionType: IsEdit,
                    item: value
                })
            })
        }
        
    }

    handlePageChanged = (value) => {
        const { formSearch } = this.state;
        this.refreshGrid(value, formSearch);
    }

    refreshGrid(page, search){
        this.handleFindSearch(page);
    }

    async handleRemoveClicked(value){
        var body = {
            "data":{
                "group-id":value.get('group-id')
            }
        };
        var temp = await this.props.actionDelete(body);
        if(temp.ok){
            Swal.fire("Deleted!", "Data has been deleted.", "success");
            toast.success('Delete '+ value.get('group-name') +' Success!', toast.POSITION.TOP_RIGHT);

        }else{
            Swal.fire("Failed!", "Failed to delete data.", "error");
            toast.error('Delete '+ value.get('group-name') +' Failed!', toast.POSITION.TOP_RIGHT);
        }
    }

    handleChange(field, value, label) {
        var formVal = this.state.searchForm;
        formVal = formVal.set(field,value);
        if(field === 'client-id'){
            this.setState({client_id: value})

            formVal = formVal.set('sender-id','')
            formVal = formVal.set('division-id','')
            this.setState({ searchForm:formVal })
            this.setState({client_id: value})

            this.props.actionGetAllDivision(value);
            this.props.actionGetAllSender(value);
            let res = null;
            let sender = [];

            setTimeout(() => {
                res = this.props.senderall;
                if (res.size > 0) sender.shift();
                {res.map((data, i) =>
                    sender.push(data.get('sender-id'))
                )}

               if(sender.length > 0) {
                   this.setState({client_id: value})
               }
            }, 1500);
        }

        if (field === 'division-id') {
            formVal = formVal.set('sender-id','')
            this.setState({ searchForm:formVal })
            this.props.actionGetAllSender(this.state.client_id, value);
        }

        this.setState({ searchForm:formVal })

    }

    handleFind(){
        this.handleFindSearch(1);
    }

    handleFindSearch(page){
        const {searchForm} = this.state;
        let client_id = searchForm.get('client-id');
        let division_id = searchForm.get('division-id');
        let sender_id = searchForm.get('sender-id');
        let res = null;
        let sender = [""];
        let datasenders = [""];
        var bodyFInd = {};
        var isAdmin = this.state.isadmin

        if (PrevilageId != 1  && isAdmin == false &&  (client_id == "" || client_id == null || client_id == undefined)) client_id = ClientId;
        if (PrevilageId != 1  && isAdmin == false && (division_id == "" || division_id == null || division_id == undefined)) division_id = DivisionId;

        this.props.actionGetAllSender(client_id, division_id)
        setTimeout(() => {
            res = this.props.senderall;
            if (res.size > 0) sender.shift();
            {res.map((data, i) =>
                sender.push(data.get('sender-id'))
            )}

            if (sender_id != "" ) sender = [sender_id]

            if ((PrevilageId == 1 || isAdmin == true) && client_id == "") client_id = 0;
            if ((PrevilageId == 1 || isAdmin == true) && division_id == "") division_id = 0;

            if (sender.length == 1 && sender[0] == null) {
                setTimeout(() => {
                    res = this.props.senderall;
                    if (res.size > 0) datasenders.shift();
                    {res.map((dataSender, i) =>
                        datasenders.push(dataSender.get('sender-id'))
                    )}

                    bodyFInd = {
                        "client-id" : client_id,
                        'division-id' : division_id,
                        "sender-id" : datasenders,
                    }

                    this.props.actionGet(page,this.state.sortForm, bodyFInd);
                }, 1500);
            } else {
                bodyFInd = {
                    "client-id" : client_id,
                    'division-id' : division_id,
                    "sender-id" : sender,
                }

                this.props.actionGet(page,this.state.sortForm, bodyFInd);
            }

        }, 1500);
    }

    showContent(){
        var form = this.state.form;

        if(form.get('show')){
            return(
                <Form 
                    actionType={ form.get('actionType') }
                    item={ form.get('item') }
                    handleCancelForm={ this.handleCancelForm }
                    handleSubmitOnForm={ this.handleSubmitOnForm }
                >
                </Form>
            )
        }else{
            const items = this.props.data ? fromJS(this.props.data) : fromJS({});

            return (
                <CustomGrid
                    title="Keygroup"
                    columns={ this.state.columns  } 
                    items={ items }  
                    search={ this.state.search }
                    handleSearch={ this.handleSearch }
                    handleViewClicked={this.handleViewClicked}
                    handleEditClicked={this.handleEditClicked}
                    handleRemoveClicked={this.handleRemoveClicked}
                    handlePageChanged={this.handlePageChanged}
                >
                </CustomGrid>
            )
        }
    }

    render(){
        const { form, searchForm, errors } = this.state;
        const title = form.get('show') ? ( form.get('actionType') === IsCreate ? "Add Key Group"  : "Edit Key Group"  ) : "Keygroup";
        const  classHide = title == 'Keygroup' ? 'card' : 'card hidden';

        return (
            <div className="clearfix">
                <div className="card-noborder">
                    <h4>
                        { title }
                    </h4>
                </div>
                <div className=  {classHide}>
                    <div className="body">
                        <div className="row">
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='client-id'
                                    value={searchForm.get('client-id')}
                                    options={fromJS({
                                        'source': this.props.clientall,
                                        'value': 'client-id',
                                        'label': 'client-name'
                                    }) }
                                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                                    placeholder="Client"
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='division-id'
                                    value={searchForm.get('division-id')}
                                    options={fromJS({
                                        'source': this.props.divisionall,
                                        'value': 'division-id',
                                        'label': 'division-name'
                                    }) }
                                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                                    placeholder="Division"
                                    disabled={this.state.disabled}
                                    hasError={errors.has('division-id')}
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='sender-id'
                                    value={searchForm.get('sender-id')}
                                    options={fromJS({
                                        'source': this.props.senderall,
                                        'value': 'sender-id',
                                        'label': 'sender-name'
                                    }) }
                                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                                    placeholder="Sender"
                                    disabled={this.state.disabled}
                                    hasError={errors.has('sender-id')}
                                />
                            </div>
                        </div>
                        <div className="row no-margin-bottom" >
                            <div className="col-sm-2">
                                <button type="button"
                                        className="btn btn-wide btn-success"
                                        onClick={this.handleFind}>
                                    Search
                                </button>
                            </div>
                            <div className="col-sm-1"></div>
                            <div className="col-sm-2">
                                <button type="button"
                                        className="btn btn-wide btn-success content-add"
                                        onClick={this.handleNew}>
                                    <i className="material-icons">{'add'}</i>{'Add'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.showContent()
                }
            </div>
        );
    }
}


export default connect(
  (state) => {
      return {
          data: state.user.keygroups,
          clientall: state.user.clientall,
          divisionall: state.user.divisionall,
          senderall: state.user.senders,
      }
  },
  dispatch => bindActionCreators({
      actionGet: ActionGet,
      actionDelete: ActionDelete,
      actionGetAllClient:ActionGetAllClient,
      actionGetAllDivision: ActionGetAllDivision,
      actionFindByGroupId:ActionFindByGroupId,
      actionGetAllSender: ActionGetAllSender,
      actionGetDetail: ActionGetDetail
  }, dispatch),
)(Page);